import { gql } from '@apollo/client';

/**
 * kan-87 — slim reuse of the existing `allCandidates` resolver. Deliberately NOT
 * the heavy CANDIDATES_LISTING document: this page only needs enough to identify
 * a candidate in a picker.
 *
 * NOTE on searching: the resolver's `searchText` arg matches first/last/full name
 * ONLY (the email branch is commented out server-side), while `columnFilters.emailSearch`
 * matches the email column. The page picks between them based on the typed text.
 */
export const SEARCH_CANDIDATES_FOR_COMPARE = gql`
  query SearchCandidatesForCompare(
    $searchText: String!
    $columnFilters: CandidateColumnFilter!
  ) {
    allCandidates(
      payload: { page: 1, limit: 10 }
      filters: {}
      columnFilters: $columnFilters
      searchText: $searchText
    ) {
      candidates {
        id
        fullName
        city
        stateCode
        emails {
          id
          email
          isPrimary
        }
      }
      count
    }
  }
`;

export const GET_CANDIDATE_RESUMES_FOR_COMPARE = gql`
  query GetCandidateResumesForCompare($candidateId: String!) {
    getCandidateResumes(candidateId: $candidateId) {
      id
      resumeFileName
      fileType
      originalUrl
      attachmentType
      uploadedAt
      createdAt
    }
  }
`;

export const COMPARE_RESUME_PARSERS = gql`
  query CompareResumeParsers($candidateId: String!, $resumeId: String!) {
    compareResumeParsers(candidateId: $candidateId, resumeId: $resumeId) {
      resumeId
      resumeFileName
      sovren
      claude
      sovrenError
      claudeError
      sovrenDurationMs
      claudeDurationMs
      diff {
        path
        status
        sovrenValue
        claudeValue
      }
      summary {
        matching
        differing
        missingInSovren
        missingInClaude
      }
    }
  }
`;
